import { render, staticRenderFns } from "./ftp.vue?vue&type=template&id=1f3f4d14"
import script from "./ftp.vue?vue&type=script&lang=js"
export * from "./ftp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports